import {Injectable, Inject} from '@angular/core';
import {v1_commonServiceName, ICommon} from '@app/v1_integration';

/**
 * Provide UI status indicators.
 * Note: For now, we create this as a wrapper around V1 ICommon service.
 */
@Injectable()
export class UIStatusService {
  constructor(@Inject(v1_commonServiceName) private _v1Common: ICommon) {}

  clearStatus() {
    this._v1Common.clearStatus();
  }

  // showHelpPopup(helpContentType: Pulse.Directives.HelpPopup.HelpContentType, helpTitle: string, helpTopicNameOrHtml: string, popupParentId: string, offsetY?: number){
  //   this._v1Common.showHelpPopup(helpContentType, helpTitle, helpTopicNameOrHtml, popupParentId, offsetY);
  // }

  showError(text: string, forceShowDetails?: boolean, options?: ToastrOptions) {
    this._v1Common.showError(text, forceShowDetails, options);
  }

  showInfo(text: string, options?: ToastrOptions) {
    this._v1Common.showInfo(text, options);
  }
  showSuccess(text: string, options?: ToastrOptions) {
    this._v1Common.showSuccess(text, options);
  }
  showWarning(text: string, options?: ToastrOptions): void {
    this._v1Common.showWarning(text, options);
  }
  toggleSpinner(
    show: boolean,
    ignoreCount?: boolean,
    opacity?: number,
    delay?: number
  ) {
    this._v1Common.toggleSpinner(show, ignoreCount, opacity, delay);
  }
}
